import { FormInputTextInput } from './component.styles'
export default FormInputTextInput
